
/**
 * Classe responsável por criar os parâmetros.
 */
export class ParametroModel {
    constructor(public chave : string, public valor: any){};
}